/* eslint-disable react-hooks/rules-of-hooks */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-22 10:53:14
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-10-09 17:23:25
 * @FilePath: /roboneo-web/src/pages/--roboneo/studio/index.page.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  useCallback, useState, useRef, useEffect,
} from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

import { ReadyState } from '$/api/fetchSSE.types';
import CalcRadish from '$/components/CalcRadish';
import NoticeFloatCard from '$/components/NoticeFloatCard';
import { FeedbackParams } from '$/pages/RoboneoChatBoard/type';
import { useLanguageStore } from '$/store/languageStore';
import useChatBoard from '$/store/useChatBoard';
import useMessagesStore from '$/store/useMessagesStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import { getUrlSearchParams } from '$/utils';
import { defineNextPage } from '@/common/next';
import UserCard from '@/components/UserCard';
import { getAccessToken } from '@/common/utils/accountUtil';
import { getGid } from '@/utils';
import { getEnv } from '@/common/agents';
import FeedbackModal from '@/components/FeedbackModal';
import HistoryModalContent from '@/components/AssetModalContent/HistoryModalContent';
import style from './index.module.scss';

const RoboneoCanvas = dynamic(
  () => import('$/pages/RoboneoCanvas'),
  { ssr: false },
);
const RoboneoAgent = dynamic(
  () => import('$/pages/RoboneoAgent'),
  { ssr: false },
);
const ExportArea = dynamic(
  () => import('$/pages/RoboneoCanvas/components/ExportArea'),
  { ssr: false },
);

// interface FeedbackParams{
//   room_id: string;
//   task_id: string;
//   image: string;
//   name?: string;
//   file?: any;
//   video?: {
//     url: string;
//     cover: string;
//   };
// }

export default defineNextPage<{
  title: string;
}>({
  pageConfig: {
    projectId: '/--roboneo',
    layoutId: 'RoboneoLayout',
    renderHead() {
      return (
        <Head>
          <title />
        </Head>
      );
    },
  },
  async getInitialProps() {
    return {
      title: 'studio',
    };
  },
  component: () => {
    const userInfo = useOfficialStore((state) => state.userInfo);
    const [feedbackParams, setFeedbackParams] = useState<FeedbackParams>();
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const languageStore = useLanguageStore((state) => state.languageStore);
    const reloadDataHandler = useMessagesStore((state) => state.reloadDataHandler);
    const readyState = useChatBoard((state: any) => state.readyState);
    const roomId = getUrlSearchParams().get('room_id') as string;
    const messageTimerRef = useRef<NodeJS.Timeout | null>(null);
    // 反馈弹窗
    const getFebackEnv = () => {
      const env = getEnv().ENV;
      if (env === 'development' || env === 'dev') {
        return 'pre';
      }
      return env as 'pre' | 'beta' | 'release';
    };

    const openFeedbackModal = useCallback((feedParams: FeedbackParams) => {
      setFeedbackParams(feedParams);
      setShowFeedbackModal(true);
      // setParam({ url: feedParams.image, name: feedParams.name });
    }, []);

    const sendErrorHandler = () => {
      if (roomId) {
        reloadDataHandler?.(roomId);
      }
    };
    const onMessageHandler = (mesData: any) => {
      // 清除之前的定时器
      if (messageTimerRef.current) {
        clearTimeout(messageTimerRef.current);
      }

      // 只有当 SSE 处于连接状态（Open）时才设置定时器刷新
      if (readyState === ReadyState.Open) {
        // 设置新的定时器：1分钟（60000毫秒）后如果没有新消息则调用 reloadDataHandler
        messageTimerRef.current = setTimeout(() => {
          if (roomId) {
            reloadDataHandler?.(roomId);
          }
        }, 60000);
      }
    };

    // 组件卸载时清除定时器
    useEffect(() => {
      return () => {
        if (messageTimerRef.current) {
          clearTimeout(messageTimerRef.current);
        }
      };
    }, []);

    return (
      <>
        <div className={style.exportBox}>
          <ExportArea />
          <UserCard style={{
            height: '100%',
            paddingRight: '8px',
          }}
          />
          {/* 剩余萝卜 */}
          <CalcRadish />
        </div>
        {/* <div className={style.copy_alter_box}>
          <IconFont name="eyeFill" fontSize={20} color="var(--content-primary)" />
          <span className={style.copy_text}>
            {languageStore.smartcatTranslationText((v) => v.roboneo_web_sharing_room_tips) }
          </span>
        </div> */}
        {/* agent 对话 */}
        <RoboneoAgent
          feedbackCallback={openFeedbackModal}
          messageHooks={{ onSendError: sendErrorHandler, onMessage: onMessageHandler }}
          // openSubscribe={openVipModal}
          // vipBgInfo={{
          //   darkVipBg: headerLogo,
          //   lightVipBg: headerLogo,
          // }}
          // chatLogoInfo={{
          //   logoText: '1111',
          //   defaultDarkLogo: headerLogo,
          //   // defaultLightLogo?: string;
          //   // thinkingLoadingDarkWebp?: string;
          //   // thinkingLoadingLightWebp?: string;
          //   // thinkingEndingDarkWebp?: string;
          //   // thinkingEndingLightWebp?: string;
          // }}
        />
        <FeedbackModal
          userInfo={userInfo}
          env={getFebackEnv()}
          client_id={getEnv().CLIENT_ID}
          gid={getGid()}
          channel=""
          language={languageStore.languageCode}
          open={showFeedbackModal}
          task_id={feedbackParams?.task_id}
          room_id={feedbackParams?.room_id}
          image={feedbackParams?.video ? undefined : feedbackParams?.image}
          video={feedbackParams?.video}
          onClose={() => setShowFeedbackModal(false)}
          getAccessToken={getAccessToken}
        />

        {/* 无线画布 */}
        <RoboneoCanvas
          // eslint-disable-next-line react/jsx-props-no-spreading -- 画布 SDK 透传历史记录选择器参数
          renderAssetModalContent={(props) => <HistoryModalContent {...props} />}
        />

        {/* 右下角运营提示卡片 */}
        <NoticeFloatCard
          style={{
            position: 'fixed',
            right: '0px',
            bottom: '104px',
          }}
          from="canvas"
        />
      </>

    );
  },
});
